// extracted by mini-css-extract-plugin
export default {"root":"dx_d5","fireLeft":"ufJtE","fireRight":"XgPyp","small":"s1RIf","xs":"qjBL1","medium":"ivUdZ","large":"t3zie"};